import { createContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const AreasContext = createContext();

// Provider con la lista de áreas publicadas (para NavBar / índice / selector).
export const AreasProvider = ({ children }) => {
  const [areas, setAreas] = useState([]);
  const [cargaAreas, setCargaAreas] = useState(true);
  const [errorAreas, setErrorAreas] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/sepeformacion/public/areas`)
      .then((res) => setAreas(res.data || []))
      .catch((err) => setErrorAreas(err))
      .finally(() => setCargaAreas(false));
  }, []);

  return (
    <AreasContext.Provider value={{ areas, cargaAreas, errorAreas }}>
      {children}
    </AreasContext.Provider>
  );
};

// Carga puntual de un área por slug. 404 si no existe o no está publicada.
export const getAreaPorSlug = async (slug) => {
  const res = await axios.get(`${API_URL}/api/sepeformacion/public/areas/${slug}`);
  return res.data;
};

// Cursos (activos y publicados) de un área.
export const getCursosDeArea = async (slug) => {
  const res = await axios.get(`${API_URL}/api/sepeformacion/public/areas/${slug}/cursos`);
  return res.data;
};

// N cursos aleatorios (activos y publicados) para la home. Cada carga cambia
// el orden. Cada curso incluye sus áreas (la card enlaza a /areas/:slug/:url).
export const getCursosAleatorios = async (limit = 8) => {
  const res = await axios.get(`${API_URL}/api/sepeformacion/public/cursos/aleatorios`, { params: { limit } });
  return res.data;
};

// Inscripción pública (lead). Guarda en BBDD + dispara emails. El backend
// valida el captcha en la misma petición (token en el body).
export const inscribirAlumnoPotencial = async (data) => {
  const res = await axios.post(`${API_URL}/api/sepeformacion/public/alumnos-potenciales`, data);
  return res.data;
};
